import React, { useState } from 'react';
import UpgradePlanModal from '../components/UpgradePlanModal';

export const useUpgradeModal = (): [React.FC, (planName?: string) => void, () => void] => {
    const [showModal, setShowModal] = useState(false);
    const [planName, setPlanName] = useState<string>();
    const handleOpen = (planName?: string | Object) => {
        if (typeof planName === 'string') {
            setPlanName(planName);
        }
        setShowModal(true);
    };
    const handleClose = () => setShowModal(false);

    return [
        () => <UpgradePlanModal isOpen={showModal} onClose={handleClose} planName={planName} />,
        handleOpen,
        handleClose,
    ];
};
